module.exports = __webpack_public_path__ + "static/media/london.7d6ef63a.jpeg";